<script>
  import { link } from "svelte-routing";

  let show = localStorage.getItem("c") !== "1";

  function acceptCookies() {
    localStorage.setItem("c", "1");
    show = false;
  }
</script>

{#if show}
  <div class="cookie-bar">
    <div class="text">
      This website uses cookies to make Bringflow work for you. By using this site, you agree to our <a href="/cookies" use:link>cookie policy</a>.
    </div>
    <div class="icon" on:click={acceptCookies}>
      <img src="/resources/images/cross.svg" alt="Close"/>
    </div>
  </div>
{/if}

<style>
  .cookie-bar {
    position: fixed;
    bottom: 15px;
    width: 730px;
    height: auto;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
    background: #fff;
    padding: 6px 5px;
    font-size: 14px;
    text-align: center;
    border-radius: 4px;
    box-shadow: #00000040 0 2px 5px;
    color: #7b7b7b;
    display: flex;
    align-items: center;
  }

  .text {
    flex: 1;
  }

  .icon {
    padding: 6px;
    cursor: pointer;
  }

  img {
    width: 12px;
    height: 12px;
  }
</style>
